import React, { useState } from 'react';
import styled from '@emotion/styled';
import OnboardingStep from './steps/OnboardingStep';
import { useCompleteOnboardingMutation } from '../../api/onboardingApi';

const OnboardingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #ff8a95, #ff6b85, #ff5577);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const OnboardingCard = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideUp 0.3s ease-out;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;


const Header = styled.div`
  padding: 32px 40px 0;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #333;
  margin: 0 0 8px;
`;

const Subtitle = styled.p`
  font-size: 16px;
  color: #666;
  margin: 0 0 32px;
`;


const StepContent = styled.div`
  padding: 0 40px 40px;
`;

export interface OnboardingData {
  plan: 'free' | 'starter' | 'pro';
  companyName: string;
}

interface OnboardingFlowProps {
  onComplete: (data: any) => void;
  onSkip?: () => void;
}

const OnboardingFlow: React.FC<OnboardingFlowProps> = ({ onComplete, onSkip }) => {
  const [onboardingData, setOnboardingData] = useState<Partial<OnboardingData>>({});
  const [completeOnboarding, { isLoading }] = useCompleteOnboardingMutation();

  const handleOnboardingComplete = async (data: OnboardingData) => {
    setOnboardingData(data);
    
    try {
      const result = await completeOnboarding({
        companyName: data.companyName,
        plan: data.plan
      }).unwrap();
      
      // The API mutation already updated Redux state and invalidated caches
      // Just call onComplete to close the onboarding flow
      onComplete(result.data);
    } catch (error) {
      console.error('Failed to complete onboarding:', error);
      // You might want to show an error message to the user here
    }
  };

  return (
    <OnboardingContainer>
      <OnboardingCard>
        <Header>
          <Title>Welcome to Chala Flow!</Title>
          <Subtitle>Set up your account to get started</Subtitle>
        </Header>

        <StepContent>
          <OnboardingStep
            data={onboardingData}
            onNext={handleOnboardingComplete}
            onSkip={onSkip}
            isLoading={isLoading}
          />
        </StepContent>
      </OnboardingCard>
    </OnboardingContainer>
  );
};

export default OnboardingFlow;